@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="toolbar">
  <button (click)="backToEntity()" [disabled]="isBusy()" matButton="text">
    <span>
      <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
      <span>Back</span>
    </span>
  </button>
  @if (entityCostReport) {
    <button (click)="exportCostReport()" [disabled]="isBusy()" matButton="text"
      matTooltip="Export the SKU and part cost breakdown for every line to a spreadsheet">
      <span>
        <mat-icon class="size-16">download</mat-icon>
        <span>Export Breakdown</span>
      </span>
    </button>
  }
  @if (canCreatePaperPilot()) {
    <button (click)="createPaperPilot()" [disabled]="isBusy()" matButton="text"
      matTooltip="Copy every line that needs cost mapping to a new Paper Pilot quote under the IEC house account">
      <span>
        <mat-icon class="size-16">flight_takeoff</mat-icon>
        <span>Create Paper Pilot</span>
      </span>
    </button>
  }
</div>
<div class="tab-content">
  @if (entityCostReport) {
    <div class="costReportWrapper">
      <div class="inputRow">
        <div class="input-group">
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Project Name:</span>
            <span class="displayFieldValue">{{ entityCostReport.projectName }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Customer:</span>
            <span class="displayFieldValue">{{ entityCostReport.buyingOrganization }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Sales Rep:</span>
            <span class="displayFieldValue">{{ entityCostReport.sellingOrganization }}</span>
          </span>
        </div>
        <span class="spacer"></span>
        <div class="input-group">
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Multiplier:</span>
            <span class="displayFieldValue numericDisplayField">{{ entityCostReport.multiplier }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Equipment Net:</span>
            <span class="displayFieldValue numericDisplayField">{{ entityCostReport.equipmentNetAmount | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Margin Amount:</span>
            <span class="displayFieldValue numericDisplayField">{{ getTotalMargin() | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Margin %:</span>
            <span class="displayFieldValue numericDisplayField">
              {{ calculateMarginPercentage(getTotalMargin(), entityCostReport.totalRevenue) }}
            </span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Total Revenue:</span>
            <span class="displayFieldValue numericDisplayField">{{ entityCostReport.totalRevenue | currency: 'USD' }}</span>
          </span>
        </div>
        <span class="spacer"></span>
        <div class="input-group">
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Total List:</span>
            <span class="displayFieldValue numericDisplayField">{{ getListAmount() | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Cost Factor:</span>
            <input type="number" class="displayFieldValue numericDisplayField" [(ngModel)]="entityCostReport.costFactor" (change)="saveCostFactor()" />
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Total Cost:</span>
            <span class="displayFieldValue numericDisplayField">{{ getTotalCost() | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Special Charges:</span>
            <span class="displayFieldValue numericDisplayField">{{ entityCostReport.specialChargeAmount | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Shipping Charges:</span>
            <span class="displayFieldValue numericDisplayField">{{ entityCostReport.shippingChargeAmount | currency: 'USD' }}</span>
          </span>
        </div>
        <span class="spacer"></span>
        <div class="input-group">
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Scenario Multiplier:</span>
            <input type="number" class="displayFieldValue numericDisplayField" [(ngModel)]="scenarioMultiplier" />
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Scenario Equipment:</span>
            <span class="displayFieldValue numericDisplayField">{{ calculateScenarioEquipment() | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Expected Margin:</span>
            <span class="displayFieldValue numericDisplayField">{{ calculateExpectedMarginAmount() | currency: 'USD' }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Expected Margin %:</span>
            <span class="displayFieldValue numericDisplayField">{{ calculateExpectedMarginPercentage() }}</span>
          </span>
          <span class="displayFieldWrapper">
            <span class="displayFieldLabel">Scenario Total:</span>
            <span class="displayFieldValue numericDisplayField">{{ calculateScenarioTotalWithShipping() | currency: 'USD' }}</span>
          </span>
        </div>
      </div>
      @if ((entityCostReport.configuredEntityLines?.length || 0) > 0) {
        <div class="lineContainer">
          <mat-accordion>
            @for (line of entityCostReport.configuredEntityLines; track line) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ line.lineId }}
                    @if (lineCostMappingStatus(line) !== 'ok') {
                      <mat-icon [class]="costMappingIconClass(lineCostMappingStatus(line))" [matTooltip]="lineCostMappingTooltip(line)">warning</mat-icon>
                    }
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="panelDescription">
                      <span class="descriptionLabel">
                        {{ line.prn?.substring(0, 70) + '...' }}
                      </span>
                      <span class="spacer"></span>
                      <span class="displayFieldWrapper">
                        <span class="lineFieldLabel">Unit Cost:</span>
                        <span class="lineDisplayField">{{ line.cost / line.quantity | currency: 'USD' }}</span>
                      </span>
                      <span class="displayFieldWrapper">
                        <span class="lineFieldLabel">Ext Cost:</span>
                        <span class="lineDisplayField">{{ line.cost | currency: 'USD' }}</span>
                      </span>
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="inputRow">
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Net Price:</span>
                    <span class="lineDisplayField">{{ line.netPrice | currency: 'USD' }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Extended Net:</span>
                    <span class="lineDisplayField">{{ line.extendedPrice | currency: 'USD' }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Quantity:</span>
                    <span class="lineDisplayField">{{ line.quantity }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Margin:</span>
                    <span class="lineDisplayField">{{ line.margin | currency: 'USD' }}</span>
                  </span>
                </div>
                <div class="expansionPanelContent">
                  <div class="skuTableWrapper">
                    <h4>Line SKUs</h4>
                    <table class="lineSkuTable">
                      <tr>
                        <td class="tableCell headerCell">Slot Name</td>
                        <td class="tableCell headerCell">Product ID</td>
                        <td class="tableCell headerCell">PRMS Lookup Key</td>
                        <td class="tableCell centeredCell headerCell">Unit Cost</td>
                        <td class="tableCell centeredCell headerCell">Ext Cost</td>
                        <td class="tableCell headerCell">Status Message</td>
                      </tr>
                      @for (sku of line.skus; track sku) {
                        <tr [class]="costMappingRowClass(skuCostMappingStatus(sku))">
                          <td class="tableCell">{{ sku.skuSlot }}</td>
                          <td class="tableCell" [class.overridden]="sku.overridden">{{ sku.skuValue }}</td>
                          <td class="tableCell">{{ sku.prmsLookupKey }}</td>
                          <td class="tableCell centeredCell">{{ sku.cost / line.quantity | currency: 'USD' }}</td>
                          <td class="tableCell centeredCell">{{ sku.cost | currency: 'USD' }}</td>
                          <td class="tableCell">
                            @if (skuCostMappingStatus(sku) !== 'ok') {
                              <mat-icon [class]="costMappingIconClass(skuCostMappingStatus(sku))" [matTooltip]="skuCostMappingTooltip(sku)">warning</mat-icon>
                            }
                            {{ sku.statusMessage }}
                          </td>
                        </tr>
                      }
                    </table>
                  </div>
                  <div class="sfrTableWrapper">
                    <h4>Line SFRs</h4>
                    <table class="lineSfrTable">
                      @for (sfr of line.appliedSfrs; track sfr) {
                        <tr>
                          <td>
                            <a target="_blank" [href]="getSfrLink(sfr)">{{ sfr }}</a>
                          </td>
                        </tr>
                      }
                    </table>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
      @if ((entityCostReport.partAndRiserLines?.length || 0) > 0) {
        <div class="lineContainer">
          <mat-accordion>
            @for (line of entityCostReport.partAndRiserLines; track line) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ line.lineId }}
                    @if (lineCostMappingStatus(line) !== 'ok') {
                      <mat-icon [class]="costMappingIconClass(lineCostMappingStatus(line))" [matTooltip]="lineCostMappingTooltip(line)">warning</mat-icon>
                    }
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="panelDescription">
                      <span class="descriptionLabel">
                        {{ line.productId }}
                      </span>
                      <span class="spacer"></span>
                      <span class="displayFieldWrapper">
                        <span class="lineFieldLabel">Unit Cost:</span>
                        <span class="lineDisplayField">{{ line.cost / line.quantity | currency: 'USD' }}</span>
                      </span>
                      <span class="displayFieldWrapper">
                        <span class="lineFieldLabel">Ext Cost:</span>
                        <span class="lineDisplayField">{{ line.cost | currency: 'USD' }}</span>
                      </span>
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="inputRow">
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Net Price:</span>
                    <span class="lineDisplayField">{{ line.netPrice | currency: 'USD' }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Extended Net:</span>
                    <span class="lineDisplayField">{{ line.extendedPrice | currency: 'USD' }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Quantity:</span>
                    <span class="lineDisplayField">{{ line.quantity }}</span>
                  </span>
                  <span class="displayFieldWrapper">
                    <span class="lineFieldLabel">Margin:</span>
                    <span class="lineDisplayField">{{ line.margin | currency: 'USD' }}</span>
                  </span>
                </div>
                <div class="expansionPanelContent">
                  <div class="partTableWrapper">
                    <h4>Line Parts</h4>
                    <table class="lineSkuTable">
                      <tr>
                        <td class="tableCell headerCell">Product ID</td>
                        <td class="tableCell headerCell">Quantity</td>
                        <td class="tableCell centeredCell headerCell">Unit Cost</td>
                        <td class="tableCell centeredCell headerCell">Ext Cost</td>
                        <td class="tableCell headerCell">Status Message</td>
                      </tr>
                      @for (part of line.parts; track part) {
                        <tr [class]="costMappingRowClass(partCostMappingStatus(part))">
                          <td class="tableCell">{{ part.productId }}</td>
                          <td class="tableCell">{{ part.quantity }}</td>
                          <td class="tableCell centeredCell">{{ part.unitCost | currency: 'USD' }}</td>
                          <td class="tableCell centeredCell">{{ part.extendedCost | currency: 'USD' }}</td>
                          <td class="tableCell">
                            @if (partCostMappingStatus(part) !== 'ok') {
                              <mat-icon [class]="costMappingIconClass(partCostMappingStatus(part))" [matTooltip]="partCostMappingTooltip()">warning</mat-icon>
                            }
                            {{ part.statusMessage }}
                          </td>
                        </tr>
                      }
                    </table>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait</span>
    </div>
  </div>
}
